import { URLS } from "@app/shared/urls";
import { PageHeader } from "@design-system/components";
import { trans } from "@mongez/localization";
import { GeneralAssemblyTabs } from "../components";

export function GeneralAssemblyPage() {
  return (
    <section className="relative min-h-dvh bg-[#f7f9fc] pb-12 text-white lg:pb-24">
      <PageHeader
        translationKey="generalAssembly"
        breadcrumbItems={[
          { label: trans("investorRelations"), link: URLS.investor.root },
          { label: trans("generalAssembly") },
        ]}
      />
      <GeneralAssemblyTabs />
    </section>
  );
}
